<template>
  <div>
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        Просмотр событий
        <div class="flex-grow-1" />
        <div style="width: 300px;">
          <v-select
            v-model="filterEvent"
            :items="eventTypes"
            label="Фильтр событий"
            item-value="id"
            item-text="name"
            hide-details
            multiple
            clearable
            @input="$emit('change', $event)"
          />
        </div>
      </v-toolbar>
      <v-data-table
        :loading="isLoading"
        hide-default-footer
        :items="isLoading ? [] : list"
        :headers="headers"
        :options.sync="options"
      >
        <template #item.event="{ item }">
          <div v-if="item.event">
            {{ eventTypesObj[item.event] || item.event }}
          </div>
        </template>
        <template #item.createdAt="{ item }">
          <div v-if="item.createdAt">
            {{ formattedDate(item.createdAt.date) }}
          </div>
        </template>
        <template #item.actions="{ item }">
          <v-btn
            color="primary"
            x-small
            @click="details(item)"
          >
            Детали
          </v-btn>
        </template>
        <template v-if="pagination" #footer>
          <v-pagination
            :length="pagination.lastPage"
            :total-visible="8"
            :value="pagination.currentPage"
            :disabled="pagination.lastPage === 1"
            color="blue darken-3"
            class="pb-4 pt-4"
            @input="updateList"
          />
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" scrollable>
      <v-card>
        <v-card-title>
          Детали события
        </v-card-title>

        <v-card-text>
          <div><b>ID</b></div>
          <div>{{ dialogData.id || '&mdash;' }}</div>
          <br>
          <div><b>Событие</b></div>
          <div>
            {{ dialogData.event || '&mdash;' }}
          </div>
          <br>
          <div><b>Сообщение</b></div>
          <div>{{ dialogData.message || '&mdash;' }}</div>
          <br>
          <div><b>Время события</b></div>
          <div>{{ dialogData.createdAt || '&mdash;' }}</div>
          <br>
          <div><b>Дополнительные данные</b></div>
          <div>
            <pre v-if="dialogData.additionalInfo">{{ dialogData.additionalInfo }}</pre>
            <template v-else>
              &mdash;
            </template>
          </div>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="error" text @click="dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'import-kafka-monitor-events',
  data: () => ({
    headers: [
      { value: 'event', text: 'Событие', sortable: true },
      { value: 'createdAt', text: 'Время события', sortable: true },
      { value: 'actions', text: '', sortable: false },
    ],
    options: {},
    isLoading: false,
    dialog: false,
    dialogData: false,
    filterEvent: [],
  }),
  computed: {
    ...mapState('kafkaImportMonitorEvents', {
      pagination: 'pagination',
      list: 'list',
      eventTypes: 'eventTypes',
    }),
    eventTypesObj() {
      const eventsObj = {};
      this.eventTypes.forEach((o) => {
        eventsObj[o.id] = o.name;
      });
      return eventsObj;
    },
    formattedDate() {
      return x => moment(x).format('DD.MM.YYYY HH:mm');
    },
  },
  watch: {
    options: {
      handler() {
        this.updateList();
      },
      deep: true,
    },
    filterEvent: {
      handler() {
        this.updateList();
      },
    },
  },
  created() {
    this.updateList();
  },
  methods: {
    ...mapActions('kafkaImportMonitorEvents', {
      getList: 'getList',
    }),
    details(item) {
      this.dialogData = { ...item };
      if (this.dialogData.createdAt) {
        this.dialogData.createdAt = this.formattedDate(
          this.dialogData.createdAt.date,
        );
      }
      if (this.dialogData.event) {
        this.dialogData.event = this.eventTypesObj[this.dialogData.event] || this.dialogData.event;
      }
      this.dialog = true;
    },
    async updateList(page = 1) {
      this.isLoading = true;
      let orderBy = null;
      let orderDir = null;
      if (
        Array.isArray(this.options.sortBy) && this.options.sortBy.length
        && Array.isArray(this.options.sortDesc) && this.options.sortDesc.length
      ) {
        [orderBy] = this.options.sortBy;
        orderDir = this.options.sortDesc[0] ? 'desc' : 'asc';
      }
      await this.getList({
        connectionId: this.$route.params.id,
        page,
        orderBy,
        orderDir,
        filterEvent: this.filterEvent,
      });
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>
